<template>
  <div class="footer" style="z-index: 1" :class="{ show: showFooter }">
    <div class="btm-offer" style="display: block; height: 105px">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-7">
            <p
              class="offer"
              v-html="this.getContent?.content?.pageBottomFooter"
            ></p>
          </div>
          <div class="col-5">
            <button
              data-bs-toggle="modal"
              data-bs-target="#registerModal"
              class="cta d-block mx-auto"
            >
              {{ this.getContent?.content?.signUpText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { store } from "@/store/store.js";

export default {
  computed: {
    getContent() {
      return {
        content: {
          // Bottom footer
          signUpText: store?.content?.signUpText,
          pageBottomFooter: store?.content?.pageBottomFooter,
        },
      };
    },
  },
  data() {
    return {
      showFooter: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 0) {
        this.showFooter = true;
      } else {
        this.showFooter = false;
      }
    },
  },
};
</script>

<style>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgb(0, 0, 0);
  display: none;
}

.footer.show {
  display: block;
}

.btm-offer {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.75);
  padding: 15px;
  height: 70px !important;
}

.container,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  max-width: 1320px;
}

.align-items-center {
  align-items: center !important;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 4rem;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  margin-left: calc(var(--bs-gutter-x) * -0.5);
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.btm-offer .offer {
  font-size: 22px;
  margin-bottom: 0;
}

.offer {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

.cta {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  background-color: #439539;
  border-radius: 2px;
  border: none;
  padding: 10px 35px;
  text-align: center;
  text-decoration: none;
}

.btm-offer .cta {
  padding: 5px;
}

.caption-inner .cta,
.btm-offer .cta {
  width: 100%;
}

.cta:hover {
  color: #fff;
}

@media (max-width: 1024px) {
  .btm-offer {
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff;
    height: 105px !important;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
}

@media (max-width: 375px) {
  .btm-offer .offer {
    font-size: 21px;
  }
}
</style>
